import { render } from "./ManagerDevicePage.vue?vue&type=template&id=12c29d85&ts=true"
import script from "./ManagerDevicePage.vue?vue&type=script&lang=ts"
export * from "./ManagerDevicePage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo/CheckDB130_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__